module.exports = __webpack_public_path__ + "img/icon-disc.33357ae2.svg";